import { render, staticRenderFns } from "./WalletLogin.vue?vue&type=template&id=cf6717cc&scoped=true&"
import script from "./WalletLogin.vue?vue&type=script&lang=js&"
export * from "./WalletLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6717cc",
  null
  
)

export default component.exports